import React, { forwardRef, useReducer } from "react";
import classNames from "classnames";
import { InputGroupProps } from "./input-group.types";
import { reducer } from "./context/reducer";
import { InputGroupContext, initialState } from "./context/context";
import { InputGroupState } from "./context/context.types";
import { FieldLevelMessage } from "../../message/field-level-message.jsx";

export const InputGroup = forwardRef<HTMLDivElement, InputGroupProps>(
  ({ stack, className, children, ...rest }, ref): React.ReactElement => {
    const classes = classNames(
      "spark-input-group",
      { "spark-input-group--stack": stack },
      className
    );
    const [state, dispatch] = useReducer(reducer, initialState);

    const value: InputGroupState = {
      ...state,
      isWithinGroup: true,
    };

    const containerAttrs: { [key: string]: string } = {};

    if (state.status) {
      containerAttrs["data-" + state.status] = "true";
    }

    return (
      <InputGroupContext.Provider value={{ state: value, dispatch }}>
        <div {...rest} ref={ref} className={classes} {...containerAttrs}>
          {children}
          {state.statusMessage ? (
            <FieldLevelMessage
              status={value.status}
              statusMessage={value.statusMessage}
            />
          ) : null}
        </div>
      </InputGroupContext.Provider>
    );
  }
);

InputGroup.displayName = "InputGroup";
